export enum eSelectedInput {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  MEDIA = 'MEDIA',
}
